import { Stack, Typography } from '@mui/material';
import settings from '/@/core/settings';
import { useHasWriteAccess } from '/@/hooks/session';
import colors from '../../theme-provider/colors';
import Alert from '../alert';

const ScheduleCard = ({
    label,
    title,
    description,
    actionText,
    actionOnClick,
    alerts = [],
}: {
    label?: string;
    title: string;
    description: string;
    actionText?: string;
    actionOnClick?: () => void;
    alerts?: string[];
}) => {
    const canCreateResource = useHasWriteAccess();

    return (
        <Stack
            sx={{
                borderRadius: 1,
                border: (t) => `1px solid ${t.palette.divider}`,
                background: colors.themes[settings.app.theme].mui.primary.infoBackground,
                p: 2,
                height: 'fit-content',
            }}
            spacing={2}
        >
            <Stack spacing={1}>
                {label && (
                    <Typography color={'primary.onSurface'} variant='overline' sx={{ textTransform: 'uppercase' }}>
                        {label}
                    </Typography>
                )}
                <Typography color={'primary'} variant='h6'>
                    {title}
                </Typography>
                <Typography color={'primary.mui.inactive'} variant='subtitle1'>
                    {description}
                </Typography>
            </Stack>
            {actionOnClick && actionText && canCreateResource && (
                <Typography
                    color={'secondary'}
                    sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                    variant='subtitle1'
                    onClick={() => {
                        actionOnClick();
                    }}
                >
                    {actionText}
                </Typography>
            )}
            {alerts.map((text) => (
                <Alert severity='surface'>{text}</Alert>
            ))}
        </Stack>
    );
};

export default ScheduleCard;
